export function createMarkup(markup: string) {
  return { __html: markup }
}

type SeoAttribute = {
  name: string
  content: string
}

type SeoItem = {
  attributes: SeoAttribute
}

type SeoData = {
  data: SeoItem[]
}

export function getMetaDescription(
  seoData: SeoData | undefined,
): string | undefined {
  if (!seoData?.data?.length) return undefined

  const description = seoData.data.find(
    item => item.attributes.name === 'description',
  )

  return description?.attributes.content
}

export function formatUrlDisplay(url: string): string {
  return url.replace(/^https?:\/\//, '')
}
